import { cn } from "@/shared/lib/utils";
import { Root } from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from "react";


const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);

const Label = forwardRef<
  ElementRef<typeof Root>,
  ComponentPropsWithoutRef<typeof Root> &
    VariantProps<typeof labelVariants>
>(({ className, ...properties }, reference) => (
  <Root
    ref={reference}
    className={cn(labelVariants(), className)}
    {...properties}
  />
));
Label.displayName = Root.displayName;

export { Label };
